import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import CasinoReport from './CasinoReport'
import CompanyConsumption from './CompanyConsumption'
import DailyRefills from './DailyRefills'
import NnReport from './NnReport'
import PurchaseOrders from './PurchaseOrders'
import RefillReport from './RefillReport'
import PartnersList from './PartnersList'
import PartnersBalance from './PartnersBalance'

const components = {
  nnreport: NnReport,
  companyConsumption: CompanyConsumption,
  purchaseOrders: PurchaseOrders,
  dailyRefills: DailyRefills,
  refillReport: RefillReport,
  casinoReport: CasinoReport,
  partnersList: PartnersList,
  PartnersBalance: PartnersBalance,
}
export default function Factory({ selected }) {
  const Component = useMemo(() => {
    return selected ? components[selected.value] : null
  })
  return Component ? <Component /> : null
}

Factory.propTypes = {
  selected: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
}
